import { all, call, fork, put, take, takeEvery } from 'redux-saga/effects';

import { handleSagaError } from '»utils/handleSagasError';

import { userInfoSlice } from '../userInfo';
import { userContactsServices } from './userContacts.services';
import { userContactsSlice } from './userContacts.slice';

const getUserContactsWorker = function* ({ payload }) {
  try {
    const { contactType } = payload;

    const userContacts = yield call(userContactsServices.userContacts, {
      contactType,
    });

    yield put(
      userContactsSlice.actions.userContactsSucess({
        userContacts,
        contactType,
      }),
    );
  } catch (error) {
    const handled = yield call(handleSagaError, error);
    if (!handled) yield put(userContactsSlice.actions.userContactsFailure());
  }
};

const setUserFavoriteContactWorker = function* ({ contactId, contactType }) {
  try {
    yield call(userContactsServices.setUserContactsFavourite, {
      contactId,
    });

    yield all([
      put(
        userContactsSlice.actions.setFavoriteContactSuccess({
          contactId,
          contactType,
        }),
      ),
      put(userInfoSlice.actions.userInfoRequest()),
    ]);
  } catch (error) {
    const handled = yield call(handleSagaError, error);
    if (!handled) yield put(userContactsSlice.actions.userContactsFailure());
  }
};

const setUserFavoriteContactSagas = function* () {
  while (true) {
    const authorized = false;
    try {
      while (!authorized) {
        const data = yield take(
          userContactsSlice.actions.setFavoriteContactRequest.type,
        );

        const { contactId, contactType } = data.payload;

        yield call(setUserFavoriteContactWorker, { contactId, contactType });
      }
    } catch {
      yield put(userContactsSlice.actions.userContactsFailure());
    }
  }
};

export const userContactsSagas = function* () {
  yield all([
    takeEvery(
      userContactsSlice.actions.userContactsRequest.type,
      getUserContactsWorker,
    ),
    fork(setUserFavoriteContactSagas),
  ]);
};
